/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PaypalService {
    /**
     * Connect a Paypal account
     * @param workspaceId Workspace ID is required in every request
     * @param requestBody
     * @returns any Successfully connected a Paypal account
     * @throws ApiError
     */
    public static postPaypal(
        workspaceId: string,
        requestBody: {
            name: string;
            client_id: string;
            client_secret: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/paypal',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * List connected Paypal accounts
     * @param workspaceId Workspace ID is required in every request
     * @returns any List connected Paypal accounts
     * @throws ApiError
     */
    public static getPaypal(
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/paypal',
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Disconnect a Paypal account
     * @param id The id of api key
     * @param workspaceId Workspace ID is required in every request
     * @returns any Successfully disconnected a Paypal account
     * @throws ApiError
     */
    public static deletePaypal(
        id: string,
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/paypal/{id}',
            path: {
                'id': id,
            },
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
}
